import PropTypes from 'prop-types';
import './thermometer.scss';

const Thermometer = ({ temperature }) => {

  const getThermometerColor = () => {
    if (temperature.value === 95) {
      return '#ed682c'; // hot
    }
    if (temperature.value === 35) {
      return '#ffcc00'; // cold
    }
    // default
    if (temperature.value === 0) {
      return 'transparent'; //
    }
    return '#f09035'; // medium
  }

  
  const getThermometerStyleVars = () => {
    return {
      "--thermometer-value": `${temperature.value}%`,
      "--thermometer-color": getThermometerColor(),
    }
  }
  
  const thermemoterStyle = getThermometerStyleVars();
  return (
    <div className='thermometer'>

      <span className='thermometer__line thermometer__line--1' />
      <span className='thermometer__line thermometer__line--2' />
      <span className='thermometer__line thermometer__line--3' />
      
      <div className='thermometer__stem'>
        <div style={thermemoterStyle} className='thermometer__stem-perct' />
      </div>
      <div className='thermometer__stem-bg' />
      <div style={thermemoterStyle} className='thermometer__bulb' />
      <div className='thermometer__bulb-bg' />
    </div>
  )
}

Thermometer.propTypes = {
  temperature: PropTypes.shape({
    value: PropTypes.number.isRequired,
    min: PropTypes.number,
    max: PropTypes.number,
  }),
}

Thermometer.defaultProps = {
  temperature: {
    value: 0,
    min: 0,
    max: 0,
  },
}

export default Thermometer;